import * as z from 'zod/mini'
import { keyedIssue } from '../errors/validation-keys'

/**
 * Field rules for a customer group, shared by the form, the HTTP body and the domain operation.
 * Compose them with `z.object({ ...customerGroupFields })`; see docs/validation.md.
 *
 * An age bound of `null` means "no bound on this side" - a group may be "12 and under",
 * "18 and over", or bounded at both ends.
 */
export const customerGroupFields = {
  name: z.string().check(z.trim(), z.minLength(2), z.maxLength(40)),
  description: z.string().check(z.maxLength(250)),
  ageStart: z.nullish(z.int().check(z.minimum(0), z.maximum(150))),
  ageEnd: z.nullish(z.int().check(z.minimum(0), z.maximum(150))),
}

/** When both age bounds are set, the lower one must not exceed the upper one. Reported on `ageEnd`. */
export const ageRange = <T extends { ageStart?: number | null; ageEnd?: number | null }>(
  value: T,
  ctx: z.core.$RefinementCtx<T>,
) => {
  const { ageStart, ageEnd } = value
  if (ageStart != null && ageEnd != null && ageStart > ageEnd) {
    ctx.addIssue(keyedIssue('validation.ageRange', ['ageEnd']))
  }
}
